import React from "react";
export const renderError = (message) => (
	<p className="text-danger">{message}</p>
);
